<ng-container [formGroup]="formGroup">
  <dsd-input
    identifier="telephone"
    formControlName="telephone"
    name="telephone"
    required="true"
    input-prefix="tel"
    type="tel"
    custom-type="tel"
    class="dsd-mb-sm">
    <span slot="label">{{ 'caad.modifier-fiserv.telephone.numeroTelephone' | translate }}</span>
    <span slot="hint">{{ 'caad.modifier-fiserv.telephone.hint' | translate }}</span>
    <span slot="error" *ngIf="!formGroup.controls.telephone.value">{{
      'caad.modifier-fiserv.telephone.erreur.telephoneVide' | translate
    }}</span>
    <span slot="error" *ngIf="formGroup.controls.telephone.value">{{
      'caad.modifier-fiserv.telephone.erreur.telephoneInvalide' | translate
    }}</span>
  </dsd-input>
</ng-container>
